(function () {
  function scrollAmount(track) {
    var tile = track.querySelector('.shop-top-categories__tile');
    if (!tile) return track.clientWidth * 0.8;

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || 0) || 12;
    return tile.getBoundingClientRect().width + gap;
  }

  function updateNavState(root) {
    var track = root.querySelector('[data-stc-track]');
    var prevBtn = root.querySelector('[data-stc-prev]');
    var nextBtn = root.querySelector('[data-stc-next]');

    if (!track) return;

    var maxScroll = track.scrollWidth - track.clientWidth;
    var canScrollPrev = track.scrollLeft > 4;
    var canScrollNext = track.scrollLeft < maxScroll - 4;

    root.classList.toggle('shop-top-categories__gallery--can-scroll-prev', canScrollPrev);

    if (prevBtn) prevBtn.disabled = !canScrollPrev;
    if (nextBtn) nextBtn.disabled = !canScrollNext;
  }

  function initShopTopCategories() {
    document.querySelectorAll('[data-shop-top-categories]').forEach(function (root) {
      if (root.dataset.stcReady === 'true') return;

      var track = root.querySelector('[data-stc-track]');
      var prevBtn = root.querySelector('[data-stc-prev]');
      var nextBtn = root.querySelector('[data-stc-next]');

      if (!track) return;

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(track), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(track), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        updateNavState(root);
      });

      window.addEventListener('resize', function () {
        updateNavState(root);
      });

      updateNavState(root);
      root.dataset.stcReady = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopTopCategories);
  } else {
    initShopTopCategories();
  }

  document.addEventListener('shopify:section:load', initShopTopCategories);
})();
